<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>赛程管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card>
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        label-width="80px"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="赛事活动" prop="activityType">
              <el-select
                disabled
                placeholder="请选择"
                style="width: 100%"
                v-model="activityType"
                @change="getList"
              >
                <el-option
                  v-for="item in activityTypeList"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="season"
                @change="getList"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span class="title_class">赛程列表</span>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <!-- <el-button type="primary" plain @click="handlaTo">字典赛季管理</el-button>
          <el-button type="primary" @click="showAdd">添加赛季</el-button> -->
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛程" prop="scheduleName"></el-table-column>
        <el-table-column label="赛程英文" prop="enName"></el-table-column>
        <el-table-column label="状态" prop="isDelete">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isDelete === 0 ? 'success' : 'danger'" size="mini">
              {{ scope.row.isDelete === 0 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="标识符" prop="scheduleFlag"></el-table-column>
        <el-table-column label="排序" prop="scheduleSort"></el-table-column>
        <el-table-column label="类型" prop="raceScheduleType"></el-table-column>

        <!-- <el-table-column label="赛季" prop="season"></el-table-column> -->
        <!-- <el-table-column label="状态" prop="isIng">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isIng === 1" type="success" size="mini">当前赛季</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              size="mini"
              :disabled="scope.row.isIng === 1"
              @click="editFn(scope.row)"
            >修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog title="修改赛程" width="480px" :visible.sync="dialogVisible">
      <el-form
        :model="editForm"
        label-width="110px"
        ref="editInfoFormRef"
        style="width: 100%"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="赛程" prop="scheduleName">
              <el-input style="width: 206px;"
                  v-model="editForm.scheduleName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="赛程英文" prop="enName">
              <el-input style="width: 206px;"
                  v-model="editForm.enName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="状态">
              <el-switch
                v-model="status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="changeStatus1"
                >
              </el-switch>
              {{ status ? '启用' : '禁用' }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activityTypeList: this.$userInfo.getDataList(this, 'activity_type').then(value => { this.activityTypeList = value }),
      activityType: String(this.$chnEngStatusCode.activityType),
      dataList: [],
      dialogVisible: false,
      editForm: {
        scheduleName: '',
        enName: '',
        id: '',
        isDelete: ''
      },
      status: false
    }
  },
  created () {
    this.getList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getList () {
      this.$http.get('raceSchedule/queryRaceScheduleSystem', { params: { activityType: this.activityType } }).then(res => {
        if (res.code === 200) {
          this.dataList = res.data
        }
      })
    },
    editFn (item) {
      this.dialogVisible = true
      this.editForm = {
        id: item.id,
        scheduleName: item.scheduleName,
        enName: item.enName,
        isDelete: item.isDelete
      }
      this.status = item.isDelete === 0
    },
    changeStatus1 () {
      this.editForm.isDelete = this.status ? 0 : 1
    },
    saveFn () {
      this.$http.post('raceSchedule/updateRaceScheduleSystem', this.editForm).then(res => {
        if (res.code === 200) {
          this.dialogVisible = false
          this.$message.success('修改成功')
          this.getList()
        }
      })
    }
  }
}

</script>
<style scoped lang="less">

</style>
